import React from 'react'

/**
 * Hook to manage `isShowNotification` state
 * This state is used to render lazy loaded @vnw/notification package
 * Should load notification package when:
 * - Has mousedown event which means user has clicked something in the site
 * - User clicks on Bell icon
 *
 */
export function useInitNotification() {
    const [isShowNotification, setIsShowNotification] = React.useState(false)

    const triggerNotification = () => {
        if (typeof window === 'undefined') return
        const event = new CustomEvent('VNW_OPEN_NOTIFICATION')
        window.dispatchEvent(event)
    }

    React.useEffect(() => {
        if (typeof document === 'undefined') return

        const notiIconNodes = document.querySelectorAll('.notification-icon')
        const burgerBtnNode = document.querySelector('.burger-btn')
        let mobileNotiIconNode: Element | null = null
        let timer: NodeJS.Timeout | null = null

        const handleClickBell = () => {
            if (!isShowNotification) {
                setIsShowNotification(true)
            } else {
                triggerNotification()
            }
        }

        const handleClickBurgerMenu = () => {
            timer && clearTimeout(timer)

            if (!isShowNotification) {
                setIsShowNotification(true)
            }

            timer = setTimeout(() => {
                mobileNotiIconNode = document.querySelector('.menu-notification')
                mobileNotiIconNode?.addEventListener('click', handleClickBell)
            }, 0)
        }

        const handleShowNotification = () => {
            if (!isShowNotification) {
                setIsShowNotification(true)
            }
        }

        notiIconNodes.forEach((node) => {
            node.addEventListener('click', handleClickBell);
        });
        burgerBtnNode?.addEventListener('click', handleClickBurgerMenu)
        window.addEventListener('mousedown', handleShowNotification, { once: true })

        return () => {
            notiIconNodes.forEach((node) => {
                node.removeEventListener('click', handleClickBell);
            });
            burgerBtnNode?.removeEventListener('click', handleClickBurgerMenu)
            mobileNotiIconNode?.removeEventListener('click', handleClickBell)
            window.removeEventListener('mousedown', handleShowNotification)
            timer && clearTimeout(timer)
        }
    }, [isShowNotification])

    return isShowNotification
}
